import { render, staticRenderFns } from "./ProductCell.vue?vue&type=template&id=44f8a8f6&scoped=true&"
import script from "./ProductCell.vue?vue&type=script&lang=js&"
export * from "./ProductCell.vue?vue&type=script&lang=js&"
import style0 from "./ProductCell.vue?vue&type=style&index=0&id=44f8a8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8a8f6",
  null
  
)

export default component.exports